@if (ready) {
  <div class="row" style="height: 320px;">
    <div class="col-1 px-0 py-2" style="max-height: 320px;">
      <div class="custom-y-axis-labels">
        @for (data of series.slice().reverse(); track data) {
          <div class="label text-start" style="padding: 12px 0px;">
            {{ data.name | titlecase }}
          </div>
        }
      </div>
    </div>
    <div class="col-11 p-0" style="max-height: 320px;">
      @if (ready) {
        <ngx-charts-heat-map class="dark"
          [scheme]="colorScheme"
          [legend]="legend"
          [animations]="animations"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [min]="min"
          [max]="max"
          [xAxis]="xAxis"
          [yAxis]="yAxis"
          [results]="chartData">
        </ngx-charts-heat-map>
      }
    </div>
  </div>
}
@if (!ready) {
  <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

